import { render, staticRenderFns } from "./DocumentRuleForm.vue?vue&type=template&id=4e510eaa&"
import script from "./DocumentRuleForm.vue?vue&type=script&lang=js&"
export * from "./DocumentRuleForm.vue?vue&type=script&lang=js&"
import style0 from "./DocumentRuleForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports